import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ServerService} from "../../../services/server.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSelect} from "@angular/material/select";
import {MatCheckbox} from "@angular/material/checkbox";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {Ordine} from "../../../models/Ordine";
import {Movimento} from "../../../models/Movimento";


@Component({
   selector: 'app-print-etichette',
   templateUrl: './print-etichette.component.html',
   styleUrls: ['./print-etichette.component.scss']
})
export class PrintEtichetteComponent implements OnInit {
   @Input() movimento: Movimento = new Movimento({})
   @Input() vendorSlug;
   @Input() pVenditaId;

   @Input() popupProfiloStampa = false;
   @Input() isSingle:boolean = false;
   @Input() maxEtichette:number = 0;

   @Output() outputEvent = new EventEmitter<any>()
   @Output() onClose = new EventEmitter<any>()

   public profiliStampanti:any[] = [];

   defaultProfiloStampante:number | null = null

   form:UntypedFormGroup = new UntypedFormGroup({})

   constructor(
      private serverSrv: ServerService,
      private router: Router,
      private route: ActivatedRoute
   ) { }

   ngOnInit(): void {
      this.getDefaultPrint()
      this.form = new UntypedFormGroup({
         profilo: new UntypedFormControl(0),
         n_skip: new UntypedFormControl(0),
         n_print: new UntypedFormControl(this.maxEtichette > 0 ? this.maxEtichette : 0),
      })
   }

   getDefaultPrint(){
      this.serverSrv.get(null, `/api/esercizi/${this.vendorSlug}/pvendita/${this.pVenditaId}/print_default`, {}).then(res =>{
         console.log(res)
         let id_profilo = res.default_print
         this.form.get('profilo')?.patchValue(id_profilo)

         this.defaultProfiloStampante = res.default_print
         console.log(this.defaultProfiloStampante)
      }).catch(err => {
         console.error(err)
      })
   }

   fetchProfiliStampanti(){
         this.serverSrv.getAll(null, `/api/esercizi/${this.vendorSlug}/profili-stampanti`, {}).then(res =>{
            this.profiliStampanti = res
         }).catch(err => {
            console.error(err)
         })
   }

   clickGoToProfiliStampanti() {
      const url = this.router.serializeUrl(this.router.createUrlTree([`../../../../impostazioni`], {relativeTo:this.route}));
      window.open(url, '_blank');
   }

   outputPrint(defaultStampa: MatCheckbox) {
      if (defaultStampa.checked){
         this.serverSrv.put(`/api/esercizi/${this.vendorSlug}/pvendita/${this.pVenditaId}/print_default`,
            {profilo_stampa:this.form.get('profilo')?.value}, null).then(res => {
            console.log(res)
         }).catch(err => {
            console.log(err)
         })
      }

      let data = {
         profilo:this.form.get('profilo')?.value,
         skipEtichette:this.form.get('n_skip')?.value,
         daStampare:this.form.get('n_print')?.value,
      }
      this.outputEvent.emit(data)
   }

   closePrintModal(){
      this.popupProfiloStampa = false
      this.onClose.emit()
   }

}
